export const DISCOUNT_ORDER_SOURCE = 'discount'
